<template>
    <div :class="isAssigned ? 'hidden' : ''">
        <div
                class="feed-element searchable_item"
                style="padding: 7px; margin-bottom: 10px; border: 1px solid #ccc"
                :style="{ cursor: loading ? 'not-allowed' : 'pointer'}"
                onmouseover="this.style.backgroundColor='#eee';"
                onmouseout="this.style.backgroundColor='#fff';"
                @click="assignTask()"
        >
            <small class="pull-right text-navy">
                <span :title="task.createdAt">{{ diffForHumans(task.createdAt) }}</span>
            </small>
            <div>
                <span style="font-weight: bold">{{task.lessonCode || 'Multiple Lessons'}}</span>
                <small>&ndash; {{task.language + ', ' + task.country}}</small>
                <i class="inline fa fa-spinner fa-spin" v-if="loading"></i>
            </div>
            <div>{{task.lessonTitle}}</div>
        </div>
    </div>
</template>


<script>
    let toastr = require('toastr');

    export default {
        props: [
            'task',
            'userId',
            'csrf',
        ],

        data() {
            return {
                loading: false,
                isAssigned: false,
            };
        },

        methods: {
            assignTask: function() {
                if (this.loading) {
                    return;
                }
                this.loading = true;
                axios.post('/task/' + this.task.id + '/assign', {'_token': this.csrf, 'user_id': this.userId})
                .then(() => {
                    this.isAssigned = true;
                    this.$emit('clicked', this.task);
                })
                .catch((error) => {
                    toastr.error('ERROR:\n' + error.response.data);
                    this.loading = false;
                    console.dir(error);
                });
            },

            moment: function() {
                return moment();
            },

            diffForHumans: function(date) {
              return moment(date).fromNow();
            },
        },

    };
</script>
